module.exports = __webpack_public_path__ + "static/media/grid-3.eca27552.jpg";